import { render } from "./IndexAgentIdForm.vue?vue&type=template&id=13227228"
import script from "./IndexAgentIdForm.vue?vue&type=script&lang=js"
export * from "./IndexAgentIdForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__